// Travel Specific Storage Identifiers
export const DECLARATION_DETAILS_STORAGE = 'SelectedTravelCoverDeclaration';
